// @flow strict

// 100 → 1
// 250 → 2.50
// 45 → 0.45
export const prettyPrintPriceFromMinor = (cents: number): string =>
  cents % 100 === 0 ? `${cents / 100}` : (cents / 100).toFixed(2)
